import styled from 'styled-components';
import media from '../../../constants/media';

export const InputWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${media.mobileOnly`
		flex-wrap: wrap;
	`};
`;

export const ButtonWrapper = styled.div`
	margin-left: 1.5rem;

	${media.mobileOnly`
		display: flex;
		justify-content: center;
		width: 100%;
		margin-left: 0;
		margin-top: 1rem;
	`};
`;

export const Wrapper = styled.div`

`;

export const TableWrapper = styled.div`
	margin-top: 2rem;
`;
